import { useTranslation } from 'react-i18next';

import { Stack } from '@mui/material';

import Progressbar from '../../../../../../components/Progressbar';
import Typography from '../../../../../../components/Typography';
import { i18nNS } from '../../../../../../i18n';
import SlideIdentifier from '../SlideIdentifier';
import usePollRemainingTime from './vm';

const PollRemainingTime = () => {
  const { t } = useTranslation([i18nNS.POLL]);

  const { remainingTimeReadable, totalTimeReadable, remainingPercentage, isPollOpen } = usePollRemainingTime();

  if (!isPollOpen) return <SlideIdentifier />;

  return (
    <Stack direction="row" alignItems="center" gap={2} p={1} m={-1}>
      <Progressbar
        shape="circular"
        variant="determinate"
        filled
        size={20}
        value={remainingPercentage}
        color="warning"
      />
      <Typography variant="textXsBold" color="warning">
        {t('R_of_T_remain', { ns: i18nNS.POLL, remainingTime: remainingTimeReadable, totalTime: totalTimeReadable })}
      </Typography>
    </Stack>
  );
};

export default PollRemainingTime;
